import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import { talentFileUploader } from "../../data-services/assignmets";

import {
  adjustBorderHeight,
  getQrCodeInfo,
} from "../../common/common";
import ProfileFileuploaderQR6slice from "../../push-components/ProfileFileuploader/ProfileFileuploaderQR6slice";
import { headset } from "ionicons/icons";



const StepQR6SliceUploadPhoto: React.FC = () => {
  const history = useHistory();

  const [fileName, setFileName] = useState('');
  const [talentHeadshot, setTalentHeadshot] = useState<string>("");

  const handleFileChange = (event:any) => {
    const file = event?.target?.files[0];
    if (file) {
      setFileName(file.name);
    }
  }

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  const onRemoveCallback = useCallback(() => {
    setTalentHeadshot("");
  }, []);

    const submitPhotoHandler = async (event: any) => {
  
      event.preventDefault();
      let model_photo = new FormData(event.target);
      model_photo.append("type", "profile_photos");
  
      console.log("model_photo", model_photo);
      // try {
        let file_upload: any = await talentFileUploader(model_photo, "");
  
      //   if (file_upload?.success) {
      //     let update_api_response = await updateTalenProfiletData({
      //       model: edit_profile_form,
      //     });
      //     if (update_api_response?.success) {
      //       await showToastMessage("Successfully Updated!");
      //       if (update_api_response?.data?.model_account_level_changed) {
      //         await invalidateOppsCache();
      //       }
      //     } else if (
      //       update_api_response?.data?.errorCode == unauthorizedErrorCode
      //     ) {
      //       dispatch(authActions.logout());
      //       return;
      //     } else if (update_api_response?.data?.errorCode == offlineErrorCode) {
      //       showToastMessage(update_api_response?.data?.message);
      //     } else if (update_api_response?.message) {
      //       showToastMessage(update_api_response.message);
      //     } else {
      //       showToastMessage(somethingWentWrongErrMsg);
      //     }
      //   } else if (file_upload?.data?.errorCode == unauthorizedErrorCode) {
      //     dispatch(authActions.logout());
      //     return;
      //   } else if (file_upload?.data?.errorCode == offlineErrorCode) {
      //     showToastMessage(file_upload?.data?.message);
      //   } else if (file_upload?.message) {
      //     showToastMessage(file_upload.message);
      //   } else {
      //     showToastMessage(somethingWentWrongErrMsg);
      //   }
      //   setShowSpinnerTillApiResponse(false);
      //   setUploadProgress(0);
      //   setRefreshComponent(!refreshComonent);
      // } catch (e: any) {
      //   if (e.message == unauthorizedErrMsg) {
      //     dispatch(authActions.logout());
      //     return;
      //   } else {
      //     showToastMessage(somethingWentWrongErrMsg);
      //     await logError(
      //       "Edit Profile - onSubmitTalentEditProfile - Exception thrown",
      //       "Talent App - Edit Profile",
      //       JSON.stringify(e.message)
      //     );
          
      //   }
      //   setShowSpinnerTillApiResponse(false);
      //   setUploadProgress(0);
      //   setRefreshComponent(!refreshComonent);
      // }
  
      history.push('/StepQR6SliceSuccessShare');
    };

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(710);
  }, []);

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      talent_mobile: "",
      talent_terms: false,
      talent_mobile_otp: "",
      promotion_text_msg: false,
      talent_fname: "",
      talent_lname: "",
      talent_display_name: "",
      talent_gender: "",
      talent_birth_date: "",
      talent_address: "",
      talent_apartment_no: "",
      talent_city: "",
      talent_country: "",
      talent_state: "",
      talent_email: "",
      marketing_emails: false,
      talent_passowrd: "",
      talent_zipcode: "",
    },
    mode: "onBlur",
  });


  return (
    <IonPage>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`}>
        <div className="lay__background">
          <img src="/images/cons/qr6slice/Background.png" />
        </div>

        <div className="lay__background lay__background--border">
          <img src="/images/cons/qr6slice/Border.png" />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>

            <div className="img__first" style={{
              marginTop: '100px',
              marginBottom: '25px',
            }}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller">
                <img src="/images/cons/qr6slice/p4-img1.png" />
              </div>
            </div>

            <form id="psup__form" onSubmit={submitPhotoHandler}>
              <div className="">
                <ProfileFileuploaderQR6slice
                  name="head_shot"
                  limit="1"
                  id="model_headshot"
                  cropp_ratio="headshot"
                  files={[]}
                  click={onRemoveCallback}
                  handleFileChange={handleFileChange}
                />
              </div>

              <div className="img__inline" style={{marginTop: '0px', position: 'relative', zIndex: 3, width: '230px'}}>
                <IonButton
                  expand="block"
                  mode="ios"
                  type="submit"
                  disabled={!fileName}
                  style={{marginTop: '0px', height: '50px'}}
                  className="form__submit-img upload-photo__submit-btn"
                  // onClick={submitPhotoHandler}
                >
                  <img src="/images/cons/qr6slice/CTA-Submit4.png" />
                </IonButton>
              </div>
            </form>
          </div>}
      </IonContent>

    </IonPage>
  );
};

export default StepQR6SliceUploadPhoto;
